<template>
  <div>
    <LoadingIndicator v-if="loading" />
    <p v-else-if="error" class="text-red-600">{{ error }}</p>
    <div v-else class="space-y-8">
      <p v-if="!caseCount" class="text-gray-700">
        No cases yet. On the Console tab, open a turn and choose <span class="font-medium">Add as a case</span>;
        the session's messages become a case that replays in that session's tenant.
      </p>
      <TestRuns :bench="bench" />
      <HermesCard title="Cases" :meta="`${caseCount} conversations the agent is tested against`" collapsible>
        <TestCases :bench="bench" @refresh="load" />
      </HermesCard>
    </div>
  </div>
</template>

<script>
import LoadingIndicator from '@/components/widgetcomponents/library/LoadingIndicator.vue';
import HermesCard from '../HermesCard.vue';
import { errorOf } from '../hermes';
import { casesOf, findBench } from './bench';
import TestCases from './TestCases.vue';
import TestRuns from './TestRuns.vue';

export default {
  name: 'HermesTests',
  components: { LoadingIndicator, HermesCard, TestCases, TestRuns },
  emits: ['crumb', 'pending'],
  data() {
    return { bench: null, loading: true, error: '' };
  },
  computed: {
    caseCount() {
      return casesOf(this.bench && this.bench.template).length;
    },
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = '';
      try {
        this.bench = await findBench(this.$axios);
      } catch (e) {
        this.error = errorOf(e, 'The bench could not be loaded.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
